import * as React from 'react';

import { Activity } from '~teacher/models/activities';

const ReportAnalyticsContext = React.createContext(null);

export interface ReportAnalytics {
  studentCount: number;
  questionCount: number;
  activity: Activity;
}

interface Props {
  children: React.ReactNode;
  analyticsData: ReportAnalytics;
}
export function ReportAnalyticsProvider({ children, analyticsData }: Props) {
  return (
    <ReportAnalyticsContext.Provider value={analyticsData}>
      {children}
    </ReportAnalyticsContext.Provider>
  );
}

export function useReportAnalytics() {
  const context = React.useContext(ReportAnalyticsContext);

  if (context === undefined) {
    throw new Error(
      'useReportAnalytics must be used within ReportAnalyticsProvider'
    );
  }

  return context;
}
